/* eslint-disable no-unused-vars */

import React from 'react';

import Icon from '@components/icon-component';

import style from './style.module.scss';
import TaskStatusAndPriority from '@components/task-status-priority';
import VesselsContainerInner from './vessel-container-inner';

const VesselsContainer = ({
  moreInfoOfVessel,
  vesselInfo = true,
  attached = [],
  deAttached = []
}) => {
  return (
    <div className={`${style.moreInfoBody} ${!vesselInfo && style.borderBottom}  `}>
      {!vesselInfo && attached?.length > 0 && (
        <div className={style.content}>
          <div className={style.verificationStatus}>
            <span className={style.title}>Attach to</span>
            <Icon name={'labelReconciled'} className={style.iconClass} />
          </div>
          {attached?.map((moreInfoOfPSV, index) => {
            return (
              <div
                key={index}
                style={{ marginBottom: index === attached?.length - 1 ? '0px' : '16px' }}
              >
                <VesselsContainerInner moreInfoOfPSV={moreInfoOfPSV} hideVerificationStatus />
              </div>
            );
          })}
        </div>
      )}
      {deAttached?.length > 0 && attached?.length > 0 && !vesselInfo && (
        <div className={style.horizontalBar}></div>
      )}

      {!vesselInfo && deAttached?.length > 0 && (
        <div className={style.content}>
          <div className={style.verificationStatus}>
            <span className={style.title}>Detach from</span>
            <Icon name={'labelReconciled'} className={style.iconClass} />
          </div>

          {deAttached?.map((moreInfoOfPSV, index) => {
            return (
              <div
                key={index}
                style={{ marginBottom: index === deAttached?.length - 1 ? '0px' : '16px' }}
              >
                <VesselsContainerInner moreInfoOfPSV={moreInfoOfPSV} hideVerificationStatus />
              </div>
            );
          })}
        </div>
      )}

      {moreInfoOfVessel?.map((moreInfoOfPSV, index) => {
        return (
          <div key={index}>
            <VesselsContainerInner moreInfoOfPSV={moreInfoOfPSV} />
          </div>
        );
      })}

      {vesselInfo && (
        <div className={`${style.vesselInfo} `}>
          <div>
            <Icon name={'info-question-icon'} />
            <p>Changes to PSV relationships can be made by editing the vessel record.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default VesselsContainer;
